import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAtomValue } from 'jotai';
import { currentContextAtom } from '../../state';
import { canEditServicesAtom } from '../state';
import { ServiceConfigurations } from './state';
import ServiceCard from './ServiceCard';

export default function CompanyServicesPage(): React.JSX.Element {
  const { t } = useTranslation(['settings']);
  const canEdit = useAtomValue(canEditServicesAtom);
  const { companyServices } = useAtomValue(currentContextAtom);

  return (
    <Box sx={{ display: 'flex', flexDirection:'column', gap: 3, p: 3 }}>
      <Typography variant="titleLarge" sx={{ display:'flex', alignItems: 'center', gap: 1 }}>
        <HandshakeOutlinedIcon />
        {t('settings:services')}
      </Typography>
      {ServiceConfigurations.map((configuration) => (
        <ServiceCard
          key={configuration.service}
          configuration={configuration}
          companyServices={companyServices}
          readOnly={!canEdit}
        />
      ))}
    </Box>
  );
}
